import React, { CSSProperties, FC, HTMLAttributes, PropsWithChildren } from 'react'
import classNames from 'classnames'
import { Footer } from '@mytours/components'

import Header, { Props as HeaderProps } from './header'
import Content from './content'

interface ContentProps extends HTMLAttributes<HTMLDivElement> {
	style?: CSSProperties & Record<string, string>
}

type FooterProps = HTMLAttributes<HTMLElement>

interface Props {
	/**
	 * The page name, emitted as a `data-cy` attribute. Nothing reads it now that the end-to-end
	 * suite is gone; it is kept as a stable hook for whatever replaces it.
	 */
	dataCy: `page-${string}`
	headerProps?: HeaderProps
	contentProps?: ContentProps
	footer?: {
		component: React.ReactNode
		props?: FooterProps
	}
	dataItemId?: string
	dataItemType?: string
	dataItemSubtype?: string
}

const Page: FC<PropsWithChildren<Props>> = ({
	dataCy,
	headerProps,
	contentProps,
	footer,
	children,
	dataItemId,
	dataItemType,
	dataItemSubtype,
}) => {
	const { component: footerComponent, props: footerProps } = footer || {}

	return (
		<Content
			{...contentProps}
			className={classNames('page-content', contentProps?.className)}
			data-item-id={dataItemId}
			data-item-type={dataItemType}
			data-item-subtype={dataItemSubtype}
			data-cy={dataCy}
		>
			{headerProps && <Header {...headerProps} className={classNames('page-header', headerProps?.className)} />}
			<div>{children}</div>
			{footerComponent && <Footer {...footerProps}>{footerComponent}</Footer>}
		</Content>
	)
}

export default Page
